import { render, staticRenderFns } from "./WorkDetails.vue?vue&type=template&id=069632ca&scoped=true&"
import script from "./WorkDetails.vue?vue&type=script&lang=js&"
export * from "./WorkDetails.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetails.vue?vue&type=style&index=0&id=069632ca&lang=scss&scoped=true&"
import style1 from "./WorkDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069632ca",
  null
  
)

export default component.exports